import { Lesson, LessonContent, LessonPin } from '@lessonup/teaching-core';
import { PinView, PlayIcon } from '@lessonup/typescript-core/ui';
import classNames from 'classnames';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from 'react-i18next';
import './ExportLessonPageView.less';

type LessonPinV1 = LessonPin<LessonContent> & {
  teacherSettings?: {
    notes?: string;
  };
};

export interface ExportLessonPageViewProps {
  lesson: Lesson | undefined;
  pins: LessonPinV1[];
}

export const ExportLessonPageView: React.FC<ExportLessonPageViewProps> = (props: ExportLessonPageViewProps) => {
  const { lesson, pins } = props;

  const urlParams = new URLSearchParams(window.location.search);
  const showNotes = urlParams.get('show-notes') === 'true';

  if (!lesson) return null;

  return (
    <div className={classNames('lesson-page-section', 'print-lesson-page-view')}>
      {pins.map((pin) => {
        const videoPin = pin.videoQuestion ? pin : undefined;
        const { type, url } = pin.item;

        const videoUrl =
          type === 'video' && url ? (
            <div className="slide-content video-url">
              <PlayIcon className="play-icon" />
              {url}
            </div>
          ) : null;

        return (
          <div className="slide-page" key={pin._id}>
            <div className="slide-wrapper" key={pin._id}>
              <PinView className="lesson-print-pin slide" pin={pin} hideFact={true} videoPin={videoPin} />
              {videoUrl}
            </div>
          </div>
        );
      })}
      {showNotes && <SlideNotes pins={pins} />}
    </div>
  );
};

interface SlideNotesProps {
  pins: LessonPinV1[];
}

const SlideNotes: React.FC<SlideNotesProps> = ({ pins }) => {
  const { t } = useTranslation('exportToPdf');
  const slidesCount = pins.length;

  const slidesWithNotes = pins
    .filter((pin) => {
      // Check both V1 and V2 note locations
      const v1Notes = pin.item.notes?.text;
      const v2Notes = pin.teacherSettings?.notes;
      return Boolean(v1Notes || v2Notes);
    })
    .map((pin) => pin.item.notes?.text || pin.teacherSettings?.notes);

  if (slidesWithNotes.length <= 0) return null;

  return (
    <div className="slide-notes">
      <h2>{t('notes')}</h2>
      {slidesWithNotes.map((note, index) => {
        const currentSlide = index + 1;

        return (
          <div className="slide-note" key={`slide-note-${index}`}>
            <h3>{`Note slide ${currentSlide}/${slidesCount}`}</h3>
            <div>{ReactHtmlParser(note)}</div>
          </div>
        );
      })}
    </div>
  );
};
